const ALPHABET =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
const ID_LENGTH = 8
let fromNpWeb = window.name.includes('newPro') && !window.name.includes('native_');
let fromNpNative = window.name.includes('newPro') && window.name.includes('native_');
function generateID() {
  let rtn = ''
  for (let i = 0; i < ID_LENGTH; i += 1) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
  }
  return rtn
}

const EventName = {
  NATIVE_ASYNC: 'native_async'
}

const registeredFunc = {}
window.nativeCall = (fName, params) => {
  if (registeredFunc[fName]) {
    registeredFunc[fName](params)
  } else {
    console.error(`error native call:${fName}`)
  }
}

const callbackResolves = {}
window.nativeCallback = function nativeCallback(uid, ret) {
  if (uid in callbackResolves && document.body.contains(callbackResolves[uid].node)) {
    document.body.removeChild(callbackResolves[uid].node)
    callbackResolves[uid].resolve(ret)
  } else {
    const iframeCallback = document.getElementsByTagName('iframe')?.[0]?.contentWindow?.nativeCallback
    if (iframeCallback) {
      iframeCallback(uid, ret)
    } else {
      console.error(`uid miss ${uid}`)
    }
  }
}

window.addEventListener('message', function(e) {
  let params = e.data
  try {
    params = typeof params === 'object' ? params : JSON.parse(params)
    if (params?.fromNewPro) {
      window.nativeCallback(params?.code ?? '', JSON.parse(params?.res ?? '{}'))
    }
  } catch (err) {

  }
})

const windowDispatchEvent = (eName, payload) => {
  if(fromNpWeb){
    window.parent.postMessage(JSON.stringify({ name: eName, src: payload.src }), '*')
  }else if(fromNpNative){
    const ev = new CustomEvent(eName, { detail: payload })
    window.dispatchEvent(ev)
  }
}

const callNativeAsyncFunc = (f, param = '') => {
  return new Promise((resolve) => {
    const uid = generateID()
    const mIframe = document.createElement('iframe')
    callbackResolves[uid] = { resolve, node: mIframe }
    const prm = typeof param === 'object' ? JSON.stringify(param) : param
    const src = `native-asyn::${f.ns}::${f.fn}::${uid}::${prm}`
    mIframe.src = src
    mIframe.name = 'native_request'
    // 设置样式
    mIframe.style.display = 'none'
    mIframe.style.width = '0'
    mIframe.style.height = '0'
    document.body.appendChild(mIframe)
    windowDispatchEvent(EventName.NATIVE_ASYNC, {
      ...param,
      src,
      uid,
      ns: f.ns,
      fn: f.fn
    })
  })
}

export {
  callNativeAsyncFunc,
  fromNpWeb,
  fromNpNative,
}
